import { useState } from "react";
import { Check } from "lucide-react";

type Option = { id: string; label: string; destaque?: boolean };

type Props = {
  options: Option[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  disabled?: boolean;
};

/**
 * Multi-select de especialidade odontológica. São 26 (CFO + Clínico Geral): as em destaque ficam à
 * vista e o resto atrás de "+ N outras" — sem virar uma parede de pills. Marcada fica sempre à vista.
 */
export function SpecialtyChips({ options, selectedIds, onToggle, disabled }: Props) {
  const [todas, setTodas] = useState(false);
  if (options.length === 0) return null;
  const temDestaque = options.some((o) => o.destaque);
  const visiveis = todas || !temDestaque ? options : options.filter((o) => o.destaque || selectedIds.includes(o.id));
  const escondidas = options.length - visiveis.length;
  return (
    <div className="flex flex-wrap gap-1.5">
      {visiveis.map((opt) => {
        const active = selectedIds.includes(opt.id);
        return (
          <button
            key={opt.id}
            type="button"
            disabled={disabled}
            aria-pressed={active}
            onClick={() => onToggle(opt.id)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[12.5px] font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
              active
                ? "border-brand-600 bg-brand-600 text-white dark:border-primary dark:bg-primary dark:text-primary-foreground"
                : "border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300 dark:border-border dark:bg-card dark:text-foreground/80 dark:hover:border-border"
            }`}
          >
            {active && <Check className="h-3 w-3" strokeWidth={3} />}
            {opt.label}
          </button>
        );
      })}
      {escondidas > 0 && (
        <button
          type="button"
          onClick={() => setTodas(true)}
          className="rounded-full px-3 py-1.5 text-[12.5px] font-semibold text-brand-700 hover:underline dark:text-primary"
        >
          + {escondidas} outras
        </button>
      )}
    </div>
  );
}
